const state = {
  isClear: false,
}

const mutations = {
  setIsClear(state, isClear) {
    state.isClear = isClear;
    setTimeout(e => {state.isClear = false;}, 1000);
  }
}

export default {
  state,
  mutations
}
  


// WEBPACK FOOTER //
// ./src/store/modules/clear.js